
const scroll = ( _args = { 
	element: null,
	inertia: null, 
	easing: null,
	active: null
}) => 
{
	// Handle document and element
	const body = document.body;
	const element = _args.element;

	// Handle ratios
	let inertia =  _args.inertia ?? 0.05;
	let easing = _args.easing ?? 6;
	let active = _args.active ?? false;
	let sx = 0;
	let sy = 0;

	let dx = sx;
	let dy = sy;

	// The trick is to set a height to the body to keep the browser scroll bar.
	body.style.height = element.clientHeight + 'px';

	// Then we fix our container so it won't move when the user scrolls.
	// We will move it ourself with the Linear Interpolation and translations.
	element.style.position = 'fixed';
	element.style.top = '-1px';
	element.style.width = '100%';
	element.style.left = '50%';

	window.scrollToAnchor = ( _x, _y ) =>
	{
			sy = _y;
			sx = _x;
			window.scrollTo(sy, sx);
	}

	// We bind a scroll event to the window to watch scroll position.
	window.addEventListener( 'scroll', () => 
	{
		if ( document.querySelector( 'html' ).getAttribute( 'data-nav-main-expanded' ) !== 'false' ) 
		{
			sy = 0;
			sx = 0;
			window.scrollTo(sy, sx);
		}
		else
		{
			sx = window.scrollX;
			sy = window.scrollY;
		}
		
	});


	// Linear Interpolation method.
	// https://www.trysmudford.com/blog/linear-interpolation-functions/
	const lerp = (a, b, n) => 
	{
		return (1 - n) * a + n * b;
	}

	const render = () =>
	{
		// Handle active
		if ( active ) easing = 0;

		// Handle lculate our container position with linear interpolation method.
		dx = parseFloat( lerp(dx, sx, inertia ) ).toFixed( easing );
		dy = parseFloat( lerp(dy, sy, inertia ) ).toFixed( easing );
		
		// Handle position change
		//element.style.transform = `translate(-${dx}px, -${dy}px)`;
		element.style.transform = `translate3D(-50%, -${dy}px, 0)`;
		
		// Handle recursive loop
		window.requestAnimationFrame( render );

	}

	// Handle `requestAnimationFrame` loop.
	window.requestAnimationFrame(render);

	// Handle only resize adjust to base
	// window.addEventListener( 'resize', () => 
	// {
	// 	body.style.height = element.clientHeight + 'px';
	// });

	
	// Handle all mutations/resizes and adjust to base
	const observer = new MutationObserver( ( mutationList, observer ) => 
	{
		for (const mutation of mutationList) {

			body.style.height = element.clientHeight + 'px';

			// if (mutation.type === "childList") {
			// 	console.log("A child node has been added or removed.");
			// } else if (mutation.type === "attributes") {
			// 	console.log(`The ${mutation.attributeName} attribute was modified.`);
			// }
		}
	});

	// Handle mutation observance
	observer.observe(
		document.querySelector( '.site' ), 
		{ 
			attributes: true, 
			childList: true, 
			subtree: true 
		}
	);

	// Later, you can stop observing
	//observer.disconnect();

	// Handle return observer
	return observer;

}

const scrollToAnchor = ( _anchor = null, _x = null, _y = null ) =>
{	
	
	// Handle with css - if set in css
	if ( !_anchor || getComputedStyle( document.documentElement ).scrollBehavior === 'auto' ) return;
	
	const anchorOffsetGet = ( _el ) => {
		var rect = _el.getBoundingClientRect(),
		scrollLeft = window.scrollX || document.documentElement.scrollLeft,
		scrollTop = window.scrollY || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }

  const anchorOffset = anchorOffsetGet( _anchor );
	
  window.scrollTo( _x ?? anchorOffset.left, _y ?? parseInt( anchorOffset.top )  );

}

export {
	scroll,
	scrollToAnchor
}